import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User updates a library member',
  name: 'update_library_member',
  params: [
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Email of the updated library member',
      name: 'library_member_email',
      required: true,
      type: 'string',
    },
    {
      description: 'The role of the updated library member',
      name: 'library_member_role_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
